import React from "react";
import { Helmet } from "react-helmet";

import Cta from "../components/cta";
import { Container, Section } from "../components/layout";
import Header from "../components/header";
import PageIntro from "../components/pageIntro";
import HousingVideos from "../components/housingVideos";
import HeaderImage from "../images/header-images/housing-dining.jpg";
import HeaderMobile from "../images/header-images/housing-dining-mobile.jpg";
import SectionLabel from "../components/sectionLabel";
import VideoContainer from "../components/videoContainer";

export default function HousingAndDining() {
  return (
    <div>
      <Helmet htmlAttributes={{lang: 'en'}}>
        <meta charSet="utf-8" />
        <title>
          Housing and Dining - International Viewbook - Maryville University
        </title>
      </Helmet>
      <Header image={HeaderImage} mobileImage={HeaderMobile} />
      <Section>
        <Container extraClasses="mb-16">
          <PageIntro
            title="Housing and Dining"
            subtitle="Amazing Housing Options."
            text="So, where will you live? We offer a variety of housing options for living on campus. All of them are awesome. There are three residence halls and an apartment complex, each with free wi-fi and cable TV. Our residence halls are social centers for many of our students, so get ready to meet lots of new people."
          />
        </Container>
        <Container extraClasses="mb-16">
          <HousingVideos />
        </Container>
        <Container>
          <PageIntro
            title="Campus Safety"
            subtitle="Safety first, always."
            text={
              "Located in one of the safest communities in St. Louis, Town and Country, Maryville’s campus is a place where everyone knows each other. There’s always a student or a faculty member around to point you in the right direction or offer you some help. In addition, The University Police patrol campus 24 hours a day, and will even escort you to your residence hall in the evenings. "
            }
          />
        </Container>
      </Section>
      <SectionLabel label="Living on Campus" />
      <VideoContainer
        embedUrl="https://www.youtube.com/embed/7AWhPC2lA4w"
        title="Living on Campus"
      />
      <Section>
        <Container extraClasses="text-center">
          <h2 className="text-2xl font-bold uppercase mb-4">Let's Eat!</h2>
          <hr className="w-2/5 lg:w-1/5 border-red mb-8 mx-auto" />
          <p className="text-gray mb-6 md:px-4">
            Gander Dining Hall is home to delicious, healthy food options, and
            it’s a hub for student activity. If you need a caffeine fix, we have
            a Starbucks located in the library. Craving a late-night snack?
            Check out Louie’s for some after-dark deliciousness.
          </p>
          <p className="text-gray md:px-4">
            <a
              href="https://www.maryville.edu/admissions/undergraduate-tuition-and-fees/"
              className="underline text-red"
              target="_blank"
              rel="noreferrer"
            >
              View the residential hall and meal plan costs.
            </a>
          </p>
        </Container>
      </Section>
      <Cta />
    </div>
  );
}
